import React, { useRef, useEffect } from 'react';
// import { StaticImage } from 'gatsby-plugin-image';

import Select from 'react-select';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TabHeaderBlock from '../components/TabHeaderBlock';
import { Dropdown, PersonDetail } from '../styles/elements';
import { WhiteBlock } from '../styles/WhiteBlock';

const workspaces = [
  { value: 'Dribbble Workspace', label: 'Dribbble Workspace' },
  { value: 'Behance Workspace', label: 'Behance Workspace' },
];
const accessDetail = [
  { value: 'Editor', label: 'Editor' },
  { value: 'Viewer', label: 'Viewer' },
];

const Members = () => {
  const PersonList = useRef();

  useEffect(() => {
    if (PersonList.current.childNodes.length > 5) {
      PersonList.current.classList.add('overflow-auto');
    }
  }, []);
  return (
    <Layout>
      <SEO title="Home" />
      <div className="db-area-main">
        <div className="db-container">
          <a href="#!" className="db-back-link button-chevron-left">
            <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
            dashboard
          </a>

          <div className="flex-row no-margin">
            <h1 className="db-heading">Workspace Setting</h1>

            <Select className="workspace-select-header" options={workspaces} />
          </div>

          <TabHeaderBlock />
          <div className="single-db-block">
            <div className="db-tab-content-block">
              <div className="flex-row">
                <div className="col col-6">
                  <WhiteBlock className="equal-height">
                    <div style={{ padding: '30px 20px' }}>
                      <div className="member-admin flex-row justify-space-between align-items-center">
                        <PersonDetail className="admin-details">
                          <div className="round-image">
                            <img src="/img/person-1.jpg" alt="" />
                          </div>
                          <div>
                            <h3>Vennis John</h3>
                            <p>veninsjhon1@gmail.com</p>
                          </div>
                        </PersonDetail>
                        <div>
                          <a href="#!" className="blue-link weight-600">
                            Admin
                          </a>
                        </div>
                      </div>

                      <p className="font-16 weight-500">Members</p>
                      <div className="member-list-main" ref={PersonList}>
                        <div className="single-member-line flex-row align-items-center">
                          <div className="col flex-1">
                            <PersonDetail>
                              <div className="round-image">
                                <img src="/img/person-1.jpg" alt="" />
                              </div>
                              <div>
                                <h3>Vennis John</h3>
                                <p>veninsjhon1@gmail.com</p>
                              </div>
                            </PersonDetail>
                          </div>

                          <div className="col flex-1 text-center">
                            <p className="no-margin" style={{ opacity: 0.4 }}>
                              4 mins ago
                            </p>
                          </div>
                          <div className="col flex-1">
                            <Select
                              className="custom-select min-width-100"
                              options={accessDetail}
                            />
                          </div>
                          <div className="col">
                            <Dropdown>
                              <span
                                style={{ opacity: 0.3 }}
                                className="dropdown-dots">
                                <span></span>
                              </span>

                              <ul className="dropdown-menu">
                                <li>
                                  <a href="#!">
                                    <img src="/img/edit.svg" alt="" /> Edit
                                  </a>
                                </li>
                                <li>
                                  <a href="#!" className="red">
                                    <img src="/img/bin.svg" alt="" /> Delete
                                  </a>
                                </li>
                              </ul>
                            </Dropdown>
                          </div>
                        </div>
                        <div className="single-member-line flex-row align-items-center">
                          <div className="col flex-1">
                            <PersonDetail>
                              <div className="round-image">WL</div>
                              <div>
                                <h3>Wayne lockz</h3>
                                <p>veninsjhon1@gmail.com</p>
                              </div>
                            </PersonDetail>
                          </div>

                          <div className="col flex-1 text-center">
                            <p className="no-margin" style={{ opacity: 0.4 }}>
                              4 mins ago
                            </p>
                          </div>
                          <div className="col flex-1">
                            <Select
                              className="custom-select min-width-100"
                              options={accessDetail}
                            />
                          </div>
                          <div className="col">
                            <Dropdown>
                              <span
                                style={{ opacity: 0.3 }}
                                className="dropdown-dots">
                                <span></span>
                              </span>

                              <ul className="dropdown-menu">
                                <li>
                                  <a href="#!">
                                    <img src="/img/edit.svg" alt="" /> Edit
                                  </a>
                                </li>
                                <li>
                                  <a href="#!" className="red">
                                    <img src="/img/bin.svg" alt="" /> Delete
                                  </a>
                                </li>
                              </ul>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
                <div className="col col-6">
                  <WhiteBlock className="equal-height">
                    <div style={{ padding: '30px 20px' }}>
                      <h3 className="db-heading no-margin">Invite Members</h3>
                      <p>
                        Members of the same Workspace can edit and access
                        stories easily.
                      </p>

                      <div className="member-invite-main">
                        <div className="member-invite-input">
                          <input
                            type="text"
                            placeholder="Enter member email..."
                          />
                          <Select
                            className="member-access-select"
                            options={accessDetail}
                          />
                        </div>
                        <div className="member-invite-button text-center">
                          <button
                            type="submit"
                            className="button"
                            style={{ minWidth: 125 }}>
                            Invite
                          </button>
                          <p className="no-margin" style={{ opacity: 0.4 }}>
                            $12/month per seat
                          </p>
                        </div>
                      </div>
                      <p className="font-16 weight-500">Members</p>
                      <div className="member-list-main" ref={PersonList}>
                        <div className="single-member-line flex-row align-items-center">
                          <div className="col flex-1">
                            <PersonDetail>
                              <div className="round-image">
                                <img src="/img/person-1.jpg" alt="" />
                              </div>
                              <div>
                                <h3>Vennis John</h3>
                                <p>veninsjhon1@gmail.com</p>
                              </div>
                            </PersonDetail>
                          </div>

                          <div className="col flex-1 text-right">
                            <p className="no-margin">Viewer</p>
                          </div>
                          <div className="col">
                            <Dropdown>
                              <span
                                style={{ opacity: 0.3 }}
                                className="dropdown-dots">
                                <span></span>
                              </span>

                              <ul className="dropdown-menu">
                                <li>
                                  <a href="#!">
                                    <img src="/img/edit.svg" alt="" /> Edit
                                  </a>
                                </li>
                                <li>
                                  <a href="#!" className="red">
                                    <img src="/img/bin.svg" alt="" /> Delete
                                  </a>
                                </li>
                              </ul>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Members;
